import React, { useState } from 'react';
import './Select.scss';

const Select = ({ options, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    const handleOptionClick = (option) => {
        setSelectedOption(option);
        onChange(option);
        setIsOpen(false);
    };

    return (
        <div className="custom-select">
            <div className="select-header" onClick={handleToggle}>
                {/* {selectedOption ? selectedOption : 'Select a car'} */}
                {'Select a car'}
                <span className="arrow">{isOpen ? '▲' : '▼'}</span>
            </div>
            {isOpen && (
                <ul className="select-options">
                    {Object.keys(options).sort().map((option, index) => (
                        <li key={index} className="select-option" onClick={() => handleOptionClick(option)}>
                            {option}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default Select;